import { useCart } from "../../context/CartContext";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import "../../assets/css/CartDrawer.css";

export default function CartDrawer({ isOpen, onClose }) {
  const {
    items, total, count,
    updateQuantity, removeFromCart, clearCart
  } = useCart();

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          onClick={onClose}
          className="cart-drawer-overlay"
        />
      )}

      {/* Drawer */}
      <div className={`cart-drawer ${!isOpen ? "closed" : ""}`}>

        {/* Header */}
        <div className="cart-drawer-header">
          <h5 className="cart-drawer-title">
            <ShoppingBag size={20} className="cart-drawer-icon" />
            Mon Panier
            {count > 0 && (
              <span className="cart-drawer-badge">{count}</span>
            )}
          </h5>
          <button
            onClick={onClose}
            className="cart-drawer-close-btn"
          >
            <X size={20} />
          </button>
        </div>

        {/* Items List */}
        <div className="cart-drawer-items">
          {items.length === 0 ? (
            <div className="cart-empty">
              <ShoppingBag className="cart-empty-icon" />
              <p>Votre panier est vide</p>
              <button
                onClick={onClose}
                className="cart-empty-btn"
              >
                Continuer mes achats
              </button>
            </div>
          ) : (
            items.map(item => (
              <div key={item.productId} className="cart-item">

                {/* Image */}
                <img
                  src={item.image || "https://via.placeholder.com/80"}
                  alt={item.name || "Produit"}
                  className="cart-item-image"
                  onError={e => e.target.src = "https://via.placeholder.com/80"}
                />

                {/* Content */}
                <div className="cart-item-content">
                  <p className="cart-item-name">
                    {item.name || "—"}
                  </p>
                  <p className="cart-item-price">
                    {((item.price || 0) * (item.quantity || 1)).toFixed(2)} MAD
                  </p>

                  {/* Quantity */}
                  <div className="cart-item-quantity">
                    <button
                      onClick={() => updateQuantity(item.productId, Math.max(1, (item.quantity || 1) - 1))}
                      className="cart-quantity-btn"
                      aria-label="Diminuer"
                    >
                      <Minus size={14} />
                    </button>
                    <span className="cart-quantity-value">
                      {item.quantity || 1}
                    </span>
                    <button
                      onClick={() => updateQuantity(item.productId, (item.quantity || 1) + 1)}
                      className="cart-quantity-btn"
                      aria-label="Augmenter"
                    >
                      <Plus size={14} />
                    </button>
                  </div>
                </div>

                {/* Remove */}
                <button
                  onClick={() => removeFromCart(item.productId)}
                  className="cart-item-remove"
                  aria-label="Supprimer"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="cart-drawer-footer">

            {/* Total */}
            <div className="cart-total-row">
              <span className="cart-total-label">Total</span>
              <span className="cart-total-amount">
                {(total || 0).toFixed(2)} MAD
              </span>
            </div>

            {/* Buttons */}
            <div className="cart-actions">
              <Link
                to="/cart"
                onClick={onClose}
                className="cart-btn cart-btn-primary"  
              >
                Voir le panier
              </Link>

              <Link
                to="/checkout"
                onClick={onClose}
                className="cart-btn cart-btn-secondary"  
              >
                Commander
              </Link>

              <button
                onClick={clearCart}
                className="cart-btn cart-btn-danger"  
              >
                Vider le panier
              </button>
            </div>

          </div>
        )}
      </div>
    </>
  );
}